import React from 'react'

import css from './style.scss'

const SaleStateText = ({ children }) => (
  <p className={css.saleStateText}>{children}</p>
)

export default SaleStateText
